import React, { useEffect } from 'react'
import * as eva from 'eva-icons'

import { ReactComponent as MProc } from '../images/mproc.svg'
import { ReactComponent as MProcOutline } from '../images/mprocOutline.svg'
import { ReactComponent as MoleTracking } from '../images/moletracking.svg'
import { ReactComponent as Check } from '../images/check.svg'
import { ReactComponent as User } from '../images/user-large.svg'

import styles from '../styles/Icon.css'

import evaOutline from '../../node_modules/eva-icons/outline-icons.json'
import evaFill from '../../node_modules/eva-icons/fill-icons.json'

const Icon = ({
  icon,
  width = '100%',
  height = '100%',
  fill = 'currentColor',
  animation = null,
  hover = false,
  infinite = false,
  className,
  onClick
}) => {
  const customIcons = [
    'm-proc',
    'm-proc-outline',
    'mole-tracking',
    'check',
    'user'
  ]

  useEffect(() => {
    const evaIcons = [...Object.keys(evaOutline), ...Object.keys(evaFill)]

    return evaIcons.includes(icon) ? eva.replace() : undefined
  }, [icon])

  const evaIcons = [...Object.keys(evaOutline), ...Object.keys(evaFill)]

  return customIcons.includes(icon) ? (
    icon === 'm-proc' ? (
      <i className={className} style={{ lineHeight: '1' }}>
        <MProc viewBox='0 0 12 12' style={{ color: fill }} />
      </i>
    ) : icon === 'm-proc-outline' ? (
      <i className={className} style={{ lineHeight: '1' }}>
        <MProcOutline viewBox='0 0 12 12' style={{ color: fill }} />
      </i>
    ) : icon === 'mole-tracking' ? (
      <i className={className} style={{ lineHeight: '1' }}>
        <MoleTracking viewBox='0 0 48 48' style={{ color: fill }} />
      </i>
    ) : icon === 'check' ? (
      <i className={className} style={{ lineHeight: '1' }}>
        <Check viewBox='0 0 20 20' style={{ color: fill }} />
      </i>
    ) : icon === 'user' ? (
      <i className={className} style={{ lineHeight: '1' }}>
        <User viewBox='0 0 48 48' style={{ color: fill }} />
      </i>
    ) : (
      ''
    )
  ) : evaIcons.includes(icon) ? (
    <i
      className={`${className !== undefined ? className : ''} ${
        styles.eva
      } eva`}
      onClick={onClick}
    >
      <i
        className={className}
        data-eva={icon}
        data-eva-animation={animation}
        data-eva-hover={hover}
        data-eva-infinite={infinite}
        data-eva-fill={fill}
        data-eva-width={width}
        data-eva-height={height}
      />
    </i>
  ) : (
    console.log(
      'Icon ' +
        icon +
        ' not found.  Double check the name from https://akveo.github.io/eva-icons/'
    )
  )
}

export default Icon
